module.exports = __webpack_public_path__ + "img/75733.5576c778.svg";